"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMplTokenAuthRulesErrorFromName = exports.getMplTokenAuthRulesErrorFromCode = exports.AlignmentErrorError = exports.DuplicatedOperationNameError = exports.RuleSetReadFailedError = exports.InvalidConstraintTypeError = exports.InvalidCompareOpError = exports.ProgramOwnedSetCheckFailedError = exports.IsWalletCheckFailedError = exports.FrequencyCheckFailedError = exports.AmountCheckFailedError = exports.ProgramOwnedTreeCheckFailedError = exports.ProgramOwnedListCheckFailedError = exports.ProgramOwnedCheckFailedError = exports.PDAMatchCheckFailedError = exports.PubkeyTreeMatchCheckFailedError = exports.PubkeyListMatchCheckFailedError = exports.PubkeyMatchCheckFailedError = exports.AdditionalSignerCheckFailedError = exports.RuleSetRevisionNotAvailableError = exports.UnexpectedRuleSetFailureError = exports.UnsupportedRuleSetVersionError = exports.UnsupportedRuleSetRevMapVersionError = exports.RuleAuthorityIsNotSignerError = exports.OperationNotFoundError = exports.NameTooLongError = exports.RuleSetOwnerMismatchError = exports.MissingPayloadValueError = exports.MissingAccountError = exports.MessagePackDeserializationErrorError = exports.MessagePackSerializationErrorError = exports.DataIsEmptyError = exports.ValueOccupiedError = exports.BorshDeserializationErrorError = exports.BorshSerializationErrorError = exports.NotImplementedError = exports.PayerIsNotSignerError = exports.DerivedKeyInvalidError = exports.PayloadVecIndexErrorError = exports.IncorrectOwnerError = exports.DataSliceUnexpectedIndexErrorError = exports.DataTypeMismatchError = exports.NumericalOverflowError = void 0;
const umi_1 = require("@metaplex-foundation/umi");
const codeToErrorMap = new Map();
const nameToErrorMap = new Map();
/** NumericalOverflow: Numerical Overflow */
class NumericalOverflowError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Numerical Overflow', program, cause);
        this.name = 'NumericalOverflow';
        this.code = 0x0; // 0
    }
}
exports.NumericalOverflowError = NumericalOverflowError;
codeToErrorMap.set(0x0, NumericalOverflowError);
nameToErrorMap.set('NumericalOverflow', NumericalOverflowError);
/** DataTypeMismatch: Data type mismatch */
class DataTypeMismatchError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Data type mismatch', program, cause);
        this.name = 'DataTypeMismatch';
        this.code = 0x1; // 1
    }
}
exports.DataTypeMismatchError = DataTypeMismatchError;
codeToErrorMap.set(0x1, DataTypeMismatchError);
nameToErrorMap.set('DataTypeMismatch', DataTypeMismatchError);
/** DataSliceUnexpectedIndexError: Data slice unexpected index error */
class DataSliceUnexpectedIndexErrorError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Data slice unexpected index error', program, cause);
        this.name = 'DataSliceUnexpectedIndexError';
        this.code = 0x2; // 2
    }
}
exports.DataSliceUnexpectedIndexErrorError = DataSliceUnexpectedIndexErrorError;
codeToErrorMap.set(0x2, DataSliceUnexpectedIndexErrorError);
nameToErrorMap.set('DataSliceUnexpectedIndexError', DataSliceUnexpectedIndexErrorError);
/** IncorrectOwner: Incorrect account owner */
class IncorrectOwnerError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Incorrect account owner', program, cause);
        this.name = 'IncorrectOwner';
        this.code = 0x3; // 3
    }
}
exports.IncorrectOwnerError = IncorrectOwnerError;
codeToErrorMap.set(0x3, IncorrectOwnerError);
nameToErrorMap.set('IncorrectOwner', IncorrectOwnerError);
/** PayloadVecIndexError: Could not index into PayloadVec */
class PayloadVecIndexErrorError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Could not index into PayloadVec', program, cause);
        this.name = 'PayloadVecIndexError';
        this.code = 0x4; // 4
    }
}
exports.PayloadVecIndexErrorError = PayloadVecIndexErrorError;
codeToErrorMap.set(0x4, PayloadVecIndexErrorError);
nameToErrorMap.set('PayloadVecIndexError', PayloadVecIndexErrorError);
/** DerivedKeyInvalid: Derived key invalid */
class DerivedKeyInvalidError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Derived key invalid', program, cause);
        this.name = 'DerivedKeyInvalid';
        this.code = 0x5; // 5
    }
}
exports.DerivedKeyInvalidError = DerivedKeyInvalidError;
codeToErrorMap.set(0x5, DerivedKeyInvalidError);
nameToErrorMap.set('DerivedKeyInvalid', DerivedKeyInvalidError);
/** PayerIsNotSigner: Payer is not a signer */
class PayerIsNotSignerError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Payer is not a signer', program, cause);
        this.name = 'PayerIsNotSigner';
        this.code = 0x6; // 6
    }
}
exports.PayerIsNotSignerError = PayerIsNotSignerError;
codeToErrorMap.set(0x6, PayerIsNotSignerError);
nameToErrorMap.set('PayerIsNotSigner', PayerIsNotSignerError);
/** NotImplemented: Not implemented */
class NotImplementedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Not implemented', program, cause);
        this.name = 'NotImplemented';
        this.code = 0x7; // 7
    }
}
exports.NotImplementedError = NotImplementedError;
codeToErrorMap.set(0x7, NotImplementedError);
nameToErrorMap.set('NotImplemented', NotImplementedError);
/** BorshSerializationError: Borsh serialization error */
class BorshSerializationErrorError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Borsh serialization error', program, cause);
        this.name = 'BorshSerializationError';
        this.code = 0x8; // 8
    }
}
exports.BorshSerializationErrorError = BorshSerializationErrorError;
codeToErrorMap.set(0x8, BorshSerializationErrorError);
nameToErrorMap.set('BorshSerializationError', BorshSerializationErrorError);
/** BorshDeserializationError: Borsh deserialization error */
class BorshDeserializationErrorError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Borsh deserialization error', program, cause);
        this.name = 'BorshDeserializationError';
        this.code = 0x9; // 9
    }
}
exports.BorshDeserializationErrorError = BorshDeserializationErrorError;
codeToErrorMap.set(0x9, BorshDeserializationErrorError);
nameToErrorMap.set('BorshDeserializationError', BorshDeserializationErrorError);
/** ValueOccupied: Value in Payload or RuleSet is occupied */
class ValueOccupiedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Value in Payload or RuleSet is occupied', program, cause);
        this.name = 'ValueOccupied';
        this.code = 0xa; // 10
    }
}
exports.ValueOccupiedError = ValueOccupiedError;
codeToErrorMap.set(0xa, ValueOccupiedError);
nameToErrorMap.set('ValueOccupied', ValueOccupiedError);
/** DataIsEmpty: Account data is empty */
class DataIsEmptyError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Account data is empty', program, cause);
        this.name = 'DataIsEmpty';
        this.code = 0xb; // 11
    }
}
exports.DataIsEmptyError = DataIsEmptyError;
codeToErrorMap.set(0xb, DataIsEmptyError);
nameToErrorMap.set('DataIsEmpty', DataIsEmptyError);
/** MessagePackSerializationError: MessagePack serialization error */
class MessagePackSerializationErrorError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('MessagePack serialization error', program, cause);
        this.name = 'MessagePackSerializationError';
        this.code = 0xc; // 12
    }
}
exports.MessagePackSerializationErrorError = MessagePackSerializationErrorError;
codeToErrorMap.set(0xc, MessagePackSerializationErrorError);
nameToErrorMap.set('MessagePackSerializationError', MessagePackSerializationErrorError);
/** MessagePackDeserializationError: MessagePack deserialization error */
class MessagePackDeserializationErrorError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('MessagePack deserialization error', program, cause);
        this.name = 'MessagePackDeserializationError';
        this.code = 0xd; // 13
    }
}
exports.MessagePackDeserializationErrorError = MessagePackDeserializationErrorError;
codeToErrorMap.set(0xd, MessagePackDeserializationErrorError);
nameToErrorMap.set('MessagePackDeserializationError', MessagePackDeserializationErrorError);
/** MissingAccount: Missing account */
class MissingAccountError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Missing account', program, cause);
        this.name = 'MissingAccount';
        this.code = 0xe; // 14
    }
}
exports.MissingAccountError = MissingAccountError;
codeToErrorMap.set(0xe, MissingAccountError);
nameToErrorMap.set('MissingAccount', MissingAccountError);
/** MissingPayloadValue: Missing Payload value */
class MissingPayloadValueError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Missing Payload value', program, cause);
        this.name = 'MissingPayloadValue';
        this.code = 0xf; // 15
    }
}
exports.MissingPayloadValueError = MissingPayloadValueError;
codeToErrorMap.set(0xf, MissingPayloadValueError);
nameToErrorMap.set('MissingPayloadValue', MissingPayloadValueError);
/** RuleSetOwnerMismatch: RuleSet owner must be payer */
class RuleSetOwnerMismatchError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('RuleSet owner must be payer', program, cause);
        this.name = 'RuleSetOwnerMismatch';
        this.code = 0x10; // 16
    }
}
exports.RuleSetOwnerMismatchError = RuleSetOwnerMismatchError;
codeToErrorMap.set(0x10, RuleSetOwnerMismatchError);
nameToErrorMap.set('RuleSetOwnerMismatch', RuleSetOwnerMismatchError);
/** NameTooLong: Name too long */
class NameTooLongError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Name too long', program, cause);
        this.name = 'NameTooLong';
        this.code = 0x11; // 17
    }
}
exports.NameTooLongError = NameTooLongError;
codeToErrorMap.set(0x11, NameTooLongError);
nameToErrorMap.set('NameTooLong', NameTooLongError);
/** OperationNotFound: The operation retrieved is not in the selected RuleSet */
class OperationNotFoundError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('The operation retrieved is not in the selected RuleSet', program, cause);
        this.name = 'OperationNotFound';
        this.code = 0x12; // 18
    }
}
exports.OperationNotFoundError = OperationNotFoundError;
codeToErrorMap.set(0x12, OperationNotFoundError);
nameToErrorMap.set('OperationNotFound', OperationNotFoundError);
/** RuleAuthorityIsNotSigner: Rule authority is not signer */
class RuleAuthorityIsNotSignerError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Rule authority is not signer', program, cause);
        this.name = 'RuleAuthorityIsNotSigner';
        this.code = 0x13; // 19
    }
}
exports.RuleAuthorityIsNotSignerError = RuleAuthorityIsNotSignerError;
codeToErrorMap.set(0x13, RuleAuthorityIsNotSignerError);
nameToErrorMap.set('RuleAuthorityIsNotSigner', RuleAuthorityIsNotSignerError);
/** UnsupportedRuleSetRevMapVersion: Unsupported RuleSet revision map version */
class UnsupportedRuleSetRevMapVersionError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Unsupported RuleSet revision map version', program, cause);
        this.name = 'UnsupportedRuleSetRevMapVersion';
        this.code = 0x14; // 20
    }
}
exports.UnsupportedRuleSetRevMapVersionError = UnsupportedRuleSetRevMapVersionError;
codeToErrorMap.set(0x14, UnsupportedRuleSetRevMapVersionError);
nameToErrorMap.set('UnsupportedRuleSetRevMapVersion', UnsupportedRuleSetRevMapVersionError);
/** UnsupportedRuleSetVersion: Unsupported RuleSet version */
class UnsupportedRuleSetVersionError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Unsupported RuleSet version', program, cause);
        this.name = 'UnsupportedRuleSetVersion';
        this.code = 0x15; // 21
    }
}
exports.UnsupportedRuleSetVersionError = UnsupportedRuleSetVersionError;
codeToErrorMap.set(0x15, UnsupportedRuleSetVersionError);
nameToErrorMap.set('UnsupportedRuleSetVersion', UnsupportedRuleSetVersionError);
/** UnexpectedRuleSetFailure: Unexpected RuleSet failure */
class UnexpectedRuleSetFailureError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Unexpected RuleSet failure', program, cause);
        this.name = 'UnexpectedRuleSetFailure';
        this.code = 0x16; // 22
    }
}
exports.UnexpectedRuleSetFailureError = UnexpectedRuleSetFailureError;
codeToErrorMap.set(0x16, UnexpectedRuleSetFailureError);
nameToErrorMap.set('UnexpectedRuleSetFailure', UnexpectedRuleSetFailureError);
/** RuleSetRevisionNotAvailable: RuleSet revision not available */
class RuleSetRevisionNotAvailableError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('RuleSet revision not available', program, cause);
        this.name = 'RuleSetRevisionNotAvailable';
        this.code = 0x17; // 23
    }
}
exports.RuleSetRevisionNotAvailableError = RuleSetRevisionNotAvailableError;
codeToErrorMap.set(0x17, RuleSetRevisionNotAvailableError);
nameToErrorMap.set('RuleSetRevisionNotAvailable', RuleSetRevisionNotAvailableError);
/** AdditionalSignerCheckFailed: Additional Signer check failed */
class AdditionalSignerCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Additional Signer check failed', program, cause);
        this.name = 'AdditionalSignerCheckFailed';
        this.code = 0x18; // 24
    }
}
exports.AdditionalSignerCheckFailedError = AdditionalSignerCheckFailedError;
codeToErrorMap.set(0x18, AdditionalSignerCheckFailedError);
nameToErrorMap.set('AdditionalSignerCheckFailed', AdditionalSignerCheckFailedError);
/** PubkeyMatchCheckFailed: Pubkey Match check failed */
class PubkeyMatchCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Pubkey Match check failed', program, cause);
        this.name = 'PubkeyMatchCheckFailed';
        this.code = 0x19; // 25
    }
}
exports.PubkeyMatchCheckFailedError = PubkeyMatchCheckFailedError;
codeToErrorMap.set(0x19, PubkeyMatchCheckFailedError);
nameToErrorMap.set('PubkeyMatchCheckFailed', PubkeyMatchCheckFailedError);
/** PubkeyListMatchCheckFailed: Pubkey List Match check failed */
class PubkeyListMatchCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Pubkey List Match check failed', program, cause);
        this.name = 'PubkeyListMatchCheckFailed';
        this.code = 0x1a; // 26
    }
}
exports.PubkeyListMatchCheckFailedError = PubkeyListMatchCheckFailedError;
codeToErrorMap.set(0x1a, PubkeyListMatchCheckFailedError);
nameToErrorMap.set('PubkeyListMatchCheckFailed', PubkeyListMatchCheckFailedError);
/** PubkeyTreeMatchCheckFailed: Pubkey Tree Match check failed */
class PubkeyTreeMatchCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Pubkey Tree Match check failed', program, cause);
        this.name = 'PubkeyTreeMatchCheckFailed';
        this.code = 0x1b; // 27
    }
}
exports.PubkeyTreeMatchCheckFailedError = PubkeyTreeMatchCheckFailedError;
codeToErrorMap.set(0x1b, PubkeyTreeMatchCheckFailedError);
nameToErrorMap.set('PubkeyTreeMatchCheckFailed', PubkeyTreeMatchCheckFailedError);
/** PDAMatchCheckFailed: PDA Match check failed */
class PDAMatchCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('PDA Match check failed', program, cause);
        this.name = 'PDAMatchCheckFailed';
        this.code = 0x1c; // 28
    }
}
exports.PDAMatchCheckFailedError = PDAMatchCheckFailedError;
codeToErrorMap.set(0x1c, PDAMatchCheckFailedError);
nameToErrorMap.set('PDAMatchCheckFailed', PDAMatchCheckFailedError);
/** ProgramOwnedCheckFailed: Program Owned check failed */
class ProgramOwnedCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Program Owned check failed', program, cause);
        this.name = 'ProgramOwnedCheckFailed';
        this.code = 0x1d; // 29
    }
}
exports.ProgramOwnedCheckFailedError = ProgramOwnedCheckFailedError;
codeToErrorMap.set(0x1d, ProgramOwnedCheckFailedError);
nameToErrorMap.set('ProgramOwnedCheckFailed', ProgramOwnedCheckFailedError);
/** ProgramOwnedListCheckFailed: Program Owned List check failed */
class ProgramOwnedListCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Program Owned List check failed', program, cause);
        this.name = 'ProgramOwnedListCheckFailed';
        this.code = 0x1e; // 30
    }
}
exports.ProgramOwnedListCheckFailedError = ProgramOwnedListCheckFailedError;
codeToErrorMap.set(0x1e, ProgramOwnedListCheckFailedError);
nameToErrorMap.set('ProgramOwnedListCheckFailed', ProgramOwnedListCheckFailedError);
/** ProgramOwnedTreeCheckFailed: Program Owned Tree check failed */
class ProgramOwnedTreeCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Program Owned Tree check failed', program, cause);
        this.name = 'ProgramOwnedTreeCheckFailed';
        this.code = 0x1f; // 31
    }
}
exports.ProgramOwnedTreeCheckFailedError = ProgramOwnedTreeCheckFailedError;
codeToErrorMap.set(0x1f, ProgramOwnedTreeCheckFailedError);
nameToErrorMap.set('ProgramOwnedTreeCheckFailed', ProgramOwnedTreeCheckFailedError);
/** AmountCheckFailed: Amount checked failed */
class AmountCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Amount checked failed', program, cause);
        this.name = 'AmountCheckFailed';
        this.code = 0x20; // 32
    }
}
exports.AmountCheckFailedError = AmountCheckFailedError;
codeToErrorMap.set(0x20, AmountCheckFailedError);
nameToErrorMap.set('AmountCheckFailed', AmountCheckFailedError);
/** FrequencyCheckFailed: Frequency check failed */
class FrequencyCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Frequency check failed', program, cause);
        this.name = 'FrequencyCheckFailed';
        this.code = 0x21; // 33
    }
}
exports.FrequencyCheckFailedError = FrequencyCheckFailedError;
codeToErrorMap.set(0x21, FrequencyCheckFailedError);
nameToErrorMap.set('FrequencyCheckFailed', FrequencyCheckFailedError);
/** IsWalletCheckFailed: IsWallet check failed */
class IsWalletCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('IsWallet check failed', program, cause);
        this.name = 'IsWalletCheckFailed';
        this.code = 0x22; // 34
    }
}
exports.IsWalletCheckFailedError = IsWalletCheckFailedError;
codeToErrorMap.set(0x22, IsWalletCheckFailedError);
nameToErrorMap.set('IsWalletCheckFailed', IsWalletCheckFailedError);
/** ProgramOwnedSetCheckFailed: Program Owned Set check failed */
class ProgramOwnedSetCheckFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Program Owned Set check failed', program, cause);
        this.name = 'ProgramOwnedSetCheckFailed';
        this.code = 0x23; // 35
    }
}
exports.ProgramOwnedSetCheckFailedError = ProgramOwnedSetCheckFailedError;
codeToErrorMap.set(0x23, ProgramOwnedSetCheckFailedError);
nameToErrorMap.set('ProgramOwnedSetCheckFailed', ProgramOwnedSetCheckFailedError);
/** InvalidCompareOp: Invalid compare operator */
class InvalidCompareOpError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Invalid compare operator', program, cause);
        this.name = 'InvalidCompareOp';
        this.code = 0x24; // 36
    }
}
exports.InvalidCompareOpError = InvalidCompareOpError;
codeToErrorMap.set(0x24, InvalidCompareOpError);
nameToErrorMap.set('InvalidCompareOp', InvalidCompareOpError);
/** InvalidConstraintType: Invalid constraint type value */
class InvalidConstraintTypeError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Invalid constraint type value', program, cause);
        this.name = 'InvalidConstraintType';
        this.code = 0x25; // 37
    }
}
exports.InvalidConstraintTypeError = InvalidConstraintTypeError;
codeToErrorMap.set(0x25, InvalidConstraintTypeError);
nameToErrorMap.set('InvalidConstraintType', InvalidConstraintTypeError);
/** RuleSetReadFailed: Failed to read the rule set */
class RuleSetReadFailedError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Failed to read the rule set', program, cause);
        this.name = 'RuleSetReadFailed';
        this.code = 0x26; // 38
    }
}
exports.RuleSetReadFailedError = RuleSetReadFailedError;
codeToErrorMap.set(0x26, RuleSetReadFailedError);
nameToErrorMap.set('RuleSetReadFailed', RuleSetReadFailedError);
/** DuplicatedOperationName: Duplicated operation name */
class DuplicatedOperationNameError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Duplicated operation name', program, cause);
        this.name = 'DuplicatedOperationName';
        this.code = 0x27; // 39
    }
}
exports.DuplicatedOperationNameError = DuplicatedOperationNameError;
codeToErrorMap.set(0x27, DuplicatedOperationNameError);
nameToErrorMap.set('DuplicatedOperationName', DuplicatedOperationNameError);
/** AlignmentError: Could not determine alignemnt */
class AlignmentErrorError extends umi_1.ProgramError {
    constructor(program, cause) {
        super('Could not determine alignemnt', program, cause);
        this.name = 'AlignmentError';
        this.code = 0x28; // 40
    }
}
exports.AlignmentErrorError = AlignmentErrorError;
codeToErrorMap.set(0x28, AlignmentErrorError);
nameToErrorMap.set('AlignmentError', AlignmentErrorError);
/**
 * Attempts to resolve a custom program error from the provided error code.
 * @category Errors
 */
function getMplTokenAuthRulesErrorFromCode(code, program, cause) {
    const constructor = codeToErrorMap.get(code);
    return constructor ? new constructor(program, cause) : null;
}
exports.getMplTokenAuthRulesErrorFromCode = getMplTokenAuthRulesErrorFromCode;
/**
 * Attempts to resolve a custom program error from the provided error name, i.e. 'Unauthorized'.
 * @category Errors
 */
function getMplTokenAuthRulesErrorFromName(name, program, cause) {
    const constructor = nameToErrorMap.get(name);
    return constructor ? new constructor(program, cause) : null;
}
exports.getMplTokenAuthRulesErrorFromName = getMplTokenAuthRulesErrorFromName;
//# sourceMappingURL=mplTokenAuthRules.js.map